export const FETCH_DEVICES = 'FETCH_DEVICES' as const;
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS' as const;
export const FETCH_DEVICES_FAIL = 'FETCH_DEVICES_FAIL' as const;
export const FETCH_DEVICES_CANCEL = 'FETCH_DEVICES_CANCEL' as const;

export const FETCH_LOGS = 'FETCH_LOGS' as const;
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS' as const;
export const FETCH_LOGS_FAIL = 'FETCH_LOGS_FAIL' as const;
export const FETCH_LOGS_CANCEL = 'FETCH_LOGS_CANCEL' as const;
export const CLEAR_LOGS = 'CLEAR_LOGS' as const;

export const FETCH_DEVICE_VERSIONS = 'FETCH_DEVICE_VERSIONS' as const;
export const FETCH_DEVICE_VERSIONS_SUCCESS = 'FETCH_DEVICE_VERSIONS_SUCCESS' as const;
export const FETCH_DEVICE_VERSIONS_FAIL = 'FETCH_DEVICE_VERSIONS_FAIL' as const;
export const FETCH_DEVICE_VERSIONS_CANCEL = 'FETCH_DEVICE_VERSIONS_CANCEL' as const;

export const SET_VERSION = 'SET_VERSION' as const;
export const SET_VERSION_SUCCESS = 'SET_VERSION_SUCCESS' as const;
export const SET_VERSION_FAIL = 'SET_VERSION_FAIL' as const;
export const SET_VERSION_CANCEL = 'SET_VERSION_CANCEL' as const;

export const SET_LEVEL = 'SET_LEVEL' as const;
export const SET_LEVEL_SUCCESS = 'SET_LEVEL_SUCCESS' as const;
export const SET_LEVEL_FAIL = 'SET_LEVEL_FAIL' as const;
export const SET_LEVEL_CANCEL = 'SET_LEVEL_CANCEL' as const;

export const SET_ENABLED = 'SET_ENABLED' as const;
export const SET_ENABLED_SUCCESS = 'SET_ENABLED_SUCCESS' as const;
export const SET_ENABLED_FAIL = 'SET_ENABLED_FAIL' as const;
export const SET_ENABLED_CANCEL = 'SET_ENABLED_CANCEL' as const;
